import React, { useEffect } from "react";

const MetaData = ({ title, description, image, keywords, url, imageWidth = 1200, imageHeight = 630 }) => {
  // Check if any required prop is undefined; if so, do not render the component.
 

  useEffect(() => {
    document.title = title;

    const setMetaTag = (name, content, property = false) => {
      let tag = document.querySelector(
        property ? `meta[property='${name}']` : `meta[name='${name}']`
      );
      if (!tag) {
        tag = document.createElement("meta");
        if (property) {
          tag.setAttribute("property", name);
        } else {
          tag.setAttribute("name", name);
        }
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };

    // Setting general metadata
    setMetaTag("description", description);
    setMetaTag("keywords", keywords);
    // Open Graph metadata
    setMetaTag("og:title", title, true);
    setMetaTag("og:description", description, true);
    setMetaTag("og:image", image, true);
    setMetaTag("og:url", url, true);
    setMetaTag("og:image:width", imageWidth, true);
    setMetaTag("og:image:height", imageHeight, true);

    // Twitter metadata
    setMetaTag("twitter:card", "summary_large_image");
    setMetaTag("twitter:title", title);
    setMetaTag("twitter:description", description);
    setMetaTag("twitter:image", image);
  }, [title, description, image, keywords, url, imageWidth, imageHeight]);


  if ([title, description, image].some(prop => prop === undefined)) {
    return null;
  }
  return null;
};

export default MetaData;
